// removed by extract-text-webpack-plugin
module.exports = {"Divider":"_1xXYA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BookingEngine/DividerIcon/DividerIcon.scss
// module id = 864
// module chunks = 0